/* eslint-disable import/named */
import memoize from 'lru-memoize';
import {useCallback} from 'react';

import {
  globalDocument,
  globalWindow,
} from '../../../../../../../libs/shared/helpers/src/browser/browserHelpers';
import {HandlerOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useWasUnmounted} from '../../../../../../../srcCommon/helpers/hookHelpers';
import {logger} from '../../../../../../../srcCommon/services/logger/logger';
import {IntegrationFileAttachment} from '../../../../../../helpers/integrationHelpers';
import {buildDropbox, DropboxChooserFile} from './dropboxChooser';

// Build the dropbox object only once.
const buildDropboxMemoized = memoize()(() => buildDropbox('7kh9bb6598tbrhm', globalWindow, globalDocument));

export function useDropboxAttachments(
  onIntegrationAttachLinks: HandlerOf<ReadonlyArray<IntegrationFileAttachment>>,
) {
  // Success event handler.
  const {wasUnmountedRef} = useWasUnmounted();
  const onSuccess = useCallback(
    (files: ReadonlyArray<DropboxChooserFile>) => {
      // Check if we're still mounted.
      if (wasUnmountedRef.current) {
        return;
      }

      // FIXME: temp logging
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      logger.info('files, within onMessage of dropboxAttachments: ', files as any);

      // If so, parse the files and notify our parent.
      const integrationFiles = files.map((f) => {
        const file: IntegrationFileAttachment = {
          name: f.name,
          url: f.link,
        };

        return file;
      });

      onIntegrationAttachLinks(integrationFiles);
    },
    [wasUnmountedRef, onIntegrationAttachLinks],
  );

  // Function to display the picker.
  const showDropboxAttachmentsPicker = useCallback(() => {
    const dropbox = buildDropboxMemoized();
    dropbox.choose({
      success: onSuccess,
      linkType: 'preview',
      multiselect: true,
    });
  }, [onSuccess]);

  return {showDropboxAttachmentsPicker};
}
